import React, { useCallback, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import "./Login.css";
import instance, { apiEncryptRequest, decryptData } from "../../Api";
import { useAuth } from "../../AuthContext";
import Loader from "../common/Loader";
import toast, { Toaster } from "react-hot-toast";
import AppToast from "../../AppToast";
import { useLocation } from "react-router-dom";

const OTPVerify2FA = ({ isMobile }) => {
  const { login, updateUserDetails, updateCurrencyRate, updateAppCurrency } = useAuth();
  const location = useLocation();

  const email  = location.state?.email  ?? null;
  const userId = location.state?.userId ?? null;

  const [inputValue, setInputValue] = useState("");
  const [loading,    setLoading]    = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // ── Toast helper ────────────────────────────────────────────────────────────
  const showToast = useCallback((msg) =>
    toast((t) => <AppToast id={t.id} message={msg} isMobile={isMobile} />),
    [isMobile]);

  // ── Currency update after login ─────────────────────────────────────────────
  const ChangeCurrency = useCallback(async (currency) => {
    try {
      const res = await instance.post("/changescurrency", { country: currency, user_id: userId });
      const { currency1, native_credit, response } = res.data;
      // Fix: original called updateCurrencyRate twice — once with currency1 (the full
      // rates object) and once with native_credit. The first call was immediately
      // overwritten by the second, so only native_credit ever took effect.
      updateCurrencyRate(native_credit);
      updateUserDetails(response);
      const key = currency === "EUR" ? "cu_EURO" : `cu_${currency}`;
      updateAppCurrency(currency1[key]);
    } catch (e) { console.error(e); }
  }, [userId, updateCurrencyRate, updateUserDetails, updateAppCurrency]);

  // ── OTP verify ──────────────────────────────────────────────────────────────
  const LoginEmailOTP = useCallback(async () => {
    if (!inputValue) { showToast("Please enter OTP"); return; }
    setLoading(true);
    try {
      const enc  = await apiEncryptRequest({ user_id: userId, email, otp: inputValue });
      const res  = await instance.post("/loginwithOtp", enc);
      const data = await decryptData(res.data);

      showToast(data.message);

      if (data.success) {
        login(data.user);
        // Fix: original called `window.location.href = "/vm/create"` TWICE —
        // once before ChangeCurrency and once after. The first redirect fires
        // immediately, so ChangeCurrency never completed. Moved to after await.
        await ChangeCurrency(data.user.currency);
        window.location.href = "/vm/create";
      }
    } catch (e) {
      console.error(e);
      showToast(String(e));
    }
    setLoading(false);
  }, [inputValue, userId, email, login, ChangeCurrency, showToast]);

  // ── Resend OTP ──────────────────────────────────────────────────────────────
  const GetOTP = useCallback(async () => {
    setLoading(true);
    try {
      const enc  = await apiEncryptRequest({ user_id: userId, email, otp: null });
      const res  = await instance.post("/getotp", enc);
      const data = await decryptData(res.data);
      showToast(data.message);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [userId, email, showToast]);

  // ── Shared form — defined once, rendered in both mobile and web ─────────────
  // Original had the entire OTP input + verify button + resend link written twice.
  const form = (
    <>
      <div className="form-top">
        <div className="input-container">
          <input
            value={inputValue}
            type="number"
            className="input-signup"
            placeholder="Enter OTP"
            onChange={(e) => setInputValue(e.target.value)}
            style={{ appearance: "none" }}
          />
        </div>
      </div>

      <div className="log-in" style={{ display: "grid", justifyItems: "center", marginTop: "2rem" }} onClick={LoginEmailOTP}>
        <button style={{ width: "15rem", marginLeft: 10, marginTop: 30, marginBottom: 10, zIndex: 9, position: "relative", fontWeight: 700, color: "white", height: 55, backgroundColor: "#e97730", outline: "4px solid #e97730", border: "4px solid white", borderRadius: 30 }}>
          Verify With OTP
        </button>
      </div>

      <div className="btm desk" style={{ paddingRight: 10, marginTop: 10 }}>
        <span className="rgst mob" style={isMobile ? { color: "white" } : undefined}>Not Received OTP? </span>
        <a className={isMobile ? "underline-text" : undefined} onClick={GetOTP} style={{ cursor: "pointer" }}>Click Here</a>
      </div>
    </>
  );

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <div>
      <div className="apptoast-align">
        <Toaster position={isMobile ? "top-center" : "bottom-right"} reverseOrder={false} />
      </div>

      {isMobile ? (
        /* ── MOBILE ──────────────────────────────────────────────────────── */
        <>
          <div className="heading-dotted-support" style={{ left: "3%" }}>
            Login With 2FA <span />
          </div>
          <div style={{ backgroundImage: `url("/images/blue-box-bg.svg")`, backgroundSize: "cover", top: "2rem", width: "90%", marginLeft: "20px", display: "flex", justifyContent: "center", alignItems: "center", padding: "30px 25px", position: "relative", backgroundColor: "#07528b", borderRadius: "12px", flexWrap: "wrap" }}>
            <form className="see-full">
              <input type="hidden" name="_token" value="IHks1cEdGGmsvouWsdVeWVHE29KFoaLV0iN8cPkE" />
              {form}
            </form>
          </div>
        </>
      ) : (
        /* ── WEB ─────────────────────────────────────────────────────────── */
        <div style={{ minHeight: "55rem" }}>
          <Row>
            <div className="col-md-4">
              <div className="heading-dotted-support" style={{ left: "15%", paddingTop: "5rem" }}>
                Login With 2FA <span />
              </div>
            </div>
            <div className="col-md-4">
              <div className="register-main see-full" style={{ marginTop: "13rem" }}>
                <div className="bg-img"><img src="/images/blue-box-bg.svg" alt="" /></div>
                <form className="see-full">
                  <input type="hidden" name="_token" value="IHks1cEdGGmsvouWsdVeWVHE29KFoaLV0iN8cPkE" />
                  {form}
                </form>
              </div>
            </div>
            <div className="col-md-4" />
          </Row>
        </div>
      )}

      {loading && (
        <div className="loading-overlay" style={{ zIndex: "9999999999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}
    </div>
  );
};

export default OTPVerify2FA;